// libs
import { css } from "@emotion/core";

// mixins
import { resetButton } from "shared/styles/mixin";

// constants
import { DWEB_MAX_WIDTH } from "shared/styles/base";

export const cssObject = css`
    .banner {
        font: normal 14px/16px cera;
        height: 24px;
        color: #fff;
        background: #000;
        position: relative;
        text-decoration: none;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .appliedCurrency {
        ${resetButton}

        position: absolute;
        left: calc(50% - ${DWEB_MAX_WIDTH / 2}px);
        cursor: pointer;
        color: #fff;

        .down {
            display: inline-block;
            height: 10px;
            width: 10px;
            position: relative;
            margin: 0 5px;
            &:before {
                content: "";
                border: 1px solid #fff;
                height: 5px;
                width: 5px;
                border-color: transparent #fff #fff transparent;
                transform: rotate(45deg);
                position: absolute;
                left: 0;
                top: 0;
            }
        }
    }
    .header-logo-svg {
        margin-bottom: 10px;
    }
`;
